<template>
  <div class="animated fadeIn">
    <div class="card" v-if="MethodService.checkHaveFeature('FT2001')">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div class="header-title">
            <h4 class="card-header-title">Kế hoạch doanh thu</h4>
          </div>
        </div>
        <div class="main-body">
          <el-table
            row-class-name="row-class"
            :cell-class-name="cellClassName"
            :data="tableData"
            style="width: 100%"
            border
            stripe
            empty-text="Không có kế hoạch nào"
            :lazy="true"
          >
            <el-table-column
              label="Phòng ban"
              min-width="240"
            >
              <template slot-scope="scope">
                <p
                  v-if="!scope.row.is_new && !scope.row.show_input"
                  @click="handleEdit(scope.row, scope.$index)"
                >
                  {{ getNameDepartment(scope.row.department_id) }}
                </p>
                <el-select
                  v-if="scope.row.show_input"
                  v-model="scope.row.department_id"
                  placeholder="Phòng ban"
                  @change="handleSelectDepartment(scope.row.department_id, scope.$index)"
                >
                  <el-option
                    v-for="(item, index) in listDepartments"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
             <el-table-column
              label="Dự án"
              min-width="240"
            >
              <template slot-scope="scope">
                <p
                  v-if="!scope.row.is_new && !scope.row.show_input"
                  @click="handleEdit(scope.row, scope.$index)"
                >
                  {{ getNameProject(scope.row.project_id) }}
                </p>
                <el-select
                  v-if="scope.row.show_input"
                  v-model="scope.row.project_id"
                  placeholder="Dự án"
                >
                  <el-option
                    v-for="(item, index) in listProjects"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="Nhân viên"
              min-width="240"
            >
              <template slot-scope="scope">
                <p
                  v-if="!scope.row.is_new && !scope.row.show_input"
                  @click="handleEdit(scope.row, scope.$index)"
                >
                  {{ getNameEmployee(scope.row.employee_id) }}
                </p>
                <el-select
                  v-if="scope.row.show_input"
                  v-model="scope.row.employee_id"
                  placeholder="Nhân viên"
                >
                  <el-option
                    v-for="(item, index) in listEmployeeOfDepartment"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="Kế hoạch"
              align="center"
              width="220"
            >
              <template slot-scope="scope">
                <p
                  v-if="!scope.row.is_new && !scope.row.show_input"
                  @click="handleEdit(scope.row, scope.$index)"
                >
                  {{ MethodService.formatCurrency(parseInt(scope.row.expected_revenue)) }}
                </p>
                <ElementUiMoney
                  @blurInput="checkInputMoney(scope.row.expected_revenue)"
                  ref="inputMoney"
                  v-if="scope.row.show_input"
                  v-model="scope.row.expected_revenue"
                  label=""
                  :outlined="true"
                  placeholder="Kế hoạch"
                  :clearable="true"
                  class="input-money"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="Deadline"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <p
                  v-if="!scope.row.is_new && !scope.row.show_input"
                  @click="handleEdit(scope.row, scope.$index)"
                >
                  {{ MethodService.formatDate(scope.row.deadline, 'date') }}
                </p>
                <el-date-picker
                  v-if="scope.row.show_input"
                  v-model="scope.row.deadline"
                  type="date"
                  format="dd/MM/yyyy"
                  placeholder="Deadline"
                >
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
              label="Mô tả chi tiết"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <el-input
                  type="textarea"
                  :rows="1"
                  placeholder="Mô tả chi tiết"
                  v-model="scope.row.note">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="Tổng doanh thu"
              align="center"
              min-width="180"
            >
              <template slot-scope="scope">
                <div v-if="!scope.row.is_new" class="total-revenue">
                  <p>
                    {{
                      scope.row.revenue_total ? MethodService.formatCurrency(scope.row.revenue_total) : 0
                    }}
                  </p>
                  <el-button
                    v-if="MethodService.checkHaveFeature('FT2003')"
                    v-b-popover.hover.left="'Cập nhật doanh thu'"
                    @click="handleShowRevenueByDay(scope.row, scope.$index)"
                    plain
                    type="success"
                  >
                    <i class="fas fa-pen"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="Thao tác"
              width="120"
              v-if="MethodService.checkHaveFeature('FT2002') || MethodService.checkHaveFeature('FT2003')"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.is_new"
                  v-b-popover.hover.left="aLang.c_create"
                  :disabled="
                    !scope.row.department_id ||
                    !scope.row.employee_id ||
                    !scope.row.expected_revenue ||
                    !scope.row.deadline ||
                    !inputMoneyValidate
                  "
                  :loading="loadingButtonCreate"
                  @click="addNewPlan(scope.row)"
                >
                  <i class="fas fa-plus-circle"></i>
                </el-button>
                <!-- Button sửa và hủy sửa -->
                <el-button
                  v-if="!scope.row.is_new && scope.row.show_input"
                  :disabled="
                    !scope.row.department_id ||
                    !scope.row.employee_id ||
                    !scope.row.expected_revenue ||
                    !scope.row.deadline ||
                    !inputMoneyValidate
                  "
                  type="success"
                  plain
                  v-b-popover.hover.left="aLang.c_update"
                  :loading="loadingButtonUpdate"
                  @click="updatePlan(scope.$index, scope.row, 'update')"
                >
                  <i class="fas fa-edit"></i>
                </el-button>
                <el-button
                  v-if="!scope.row.is_new && scope.row.show_input"
                  type="danger"
                  plain
                  v-b-popover.hover.left="'Hủy'"
                  @click="updatePlan(scope.$index, scope.row, 'cancel')"
                >
                  <i class="far fa-window-close"></i>
                </el-button>
                <!-- Button xóa -->
                <el-button
                  v-if="!scope.row.is_new && !scope.row.show_input && MethodService.checkHaveFeature('FT2003')"
                  type="danger"
                  plain
                  v-b-popover.hover.left="aLang.c_delete"
                  @click="deletePlan(scope.row)"
                >
                  <i class="fas fa-trash-alt"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="text-right">
            <el-pagination
              class="mt-2"
              v-if="tableRules.total > 0"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="tableRules.lengthMenu"
              :page-size="tableRules.limit"
              :current-page="tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              :pager-count="5"
            />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="dialog-revenue-by-day"
      title="Doanh thu theo ngày"
      :visible.sync="showRevenueByDay"
      :before-close="revenueByDayClose"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div>
        <el-table
          border
          :data="dataRevenueByDay"
          style="width: 100%"
        >
          <el-table-column
            prop="prop"
            label="Ngày"
            width="250"
            align="center"
          >
            <template slot-scope="scope">
              <p
                v-if="!scope.row.is_new && !scope.row.show_input"
                @click="handleEditTable(scope.row, scope.$index)"
              >
                {{ MethodService.formatDate(scope.row.revenue_date, 'date') }}
              </p>
              <el-date-picker
                v-if="scope.row.show_input"
                v-model="scope.row.revenue_date"
                :picker-options="pickerOptions"
                type="date"
                format="dd/MM/yyyy"
                placeholder="Ngày"
              >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            prop="prop"
            label="Doanh thu"
            min-width="240"
            align="center"
          >
            <template slot-scope="scope">
              <p
                v-if="!scope.row.is_new && !scope.row.show_input"
                @click="handleEditTable(scope.row, scope.$index)"
              >
                {{ MethodService.formatCurrency(parseInt(scope.row.revenue)) }}
              </p>
              <ElementUiMoney
                @blurInput="checkRevenueByDayInputMoney(scope.row.revenue)"
                :ref="'revenueByDay'"
                v-if="scope.row.show_input"
                v-model="scope.row.revenue"
                label=""
                :outlined="true"
                placeholder="Doanh thu"
                :clearable="true"
                class="input-money"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="prop"
            label="Loại doanh thu"
            width="220"
            align="center"
          >
            <template slot-scope="scope">
              <p
                v-if="!scope.row.is_new && !scope.row.show_input"
                @click="handleEditTable(scope.row, scope.$index)"
              >
                {{
                  scope.row.type == "NEW" ? "Doanh thu mới" : "Doanh thu duy trì"
                }}
              </p>
              <el-select
                v-if="scope.row.show_input"
                v-model="scope.row.type"
                placeholder="Loại doanh thu"
              >
                <el-option
                  v-for="item in listTypeRevenue"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column
            prop="prop"
            label="Đánh giá"
            width="220"
            align="center"
          >
            <template slot-scope="scope">
              <el-input placeholder="Đánh giá" v-model="scope.row.rating"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="Ghi chú"
            min-width="240"
          >
            <template slot-scope="scope">
              <p
                class="note"
                v-if="!scope.row.is_new && !scope.row.show_input"
                @click="handleEditTable(scope.row, scope.$index)"
                :title="scope.row.note"
              >
                {{ scope.row.note }}
              </p>
              <el-input
                v-if="scope.row.show_input"
                v-model="scope.row.note"
                @change="() => scope.row.note = scope.row.note.trim()"
                type="textarea"
                :row="2"
                clearable
                placeholder="Ghi chú"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="prop"
            label="Thao tác"
            width="130"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                  v-if="scope.row.is_new"
                  v-b-popover.hover.left="{
                    content: aLang.c_create,
                    delay: {
                      'show': 10,
                      'hide': 0
                    }
                  }"
                  :disabled="
                    !scope.row.revenue_date ||
                    !scope.row.revenue ||
                    !scope.row.type ||
                    !inputRevenueByDayMoneyValidate
                  "
                  :loading="loadingButtonCreateRevenueByDay"
                  @click="addNewRevenueByDay(scope.row)"
                >
                  <i class="fas fa-plus-circle"></i>
                </el-button>
              <!-- Button sửa và hủy sửa -->
              <el-button
                  v-if="!scope.row.is_new && scope.row.show_input"
                  :disabled="
                    !scope.row.revenue_date ||
                    !scope.row.revenue ||
                    !scope.row.type ||
                    !inputRevenueByDayMoneyValidate
                  "
                  type="success"
                  plain
                  v-b-popover.hover.left="aLang.c_update"
                  :loading="loadingButtonUpdateRevenueByDay"
                  @click="updateRevenueByDay(scope.$index, scope.row, 'update')"
                >
                  <i class="fas fa-edit"></i>
                </el-button>
                <el-button
                  v-if="!scope.row.is_new && scope.row.show_input"
                  type="danger"
                  plain
                  v-b-popover.hover.left="'Hủy'"
                  @click="updateRevenueByDay(scope.$index, scope.row, 'cancel')"
                >
                  <i class="far fa-window-close"></i>
                </el-button>
              <!-- Button sửa và hủy sửa -->
              <el-button
                v-if="!scope.row.is_new && !scope.row.show_input"
                type="danger"
                plain
                v-b-popover.hover.left="'Xóa'"
                @click="deleteRevenueByDay(scope.row)"
              >
                <i class="fas fa-trash-alt"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="text-right">
          <el-pagination
            class="mt-2"
            v-if="tableRuleRevenuByDays.total > 0"
            @size-change="fn_tableRevenuByDaySizeChange"
            @current-change="fn_tableRevenuByDayCurentChange"
            @prev-click="fn_tableRevenuByDayPrevClick"
            @next-click="fn_tableRevenuByDayNextClick"
            :page-sizes="tableRuleRevenuByDays.lengthMenu"
            :page-size="tableRuleRevenuByDays.limit"
            :current-page="tableRuleRevenuByDays.page"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableRuleRevenuByDays.total"
            :pager-count="5"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService'
import MethodService from '../../../service/MethodService'
import BusinessModel from './BusinessModel'
import BusinessPlanApi from '../../../moduleApi/BusinessPlanApi'
import RevenueByDayApi from '../../../moduleApi/RevenueByDayApi'
import DepartmentApi from '../../../moduleApi/DepartmentApi'
import EmployeeApi from '../../../moduleApi/EmployeeApi'
import ElementUiMoney from '@/component/InputComponent/ElementUiMoney'
import EventBus from '../../../service/EventBus'
import ProjectApi from "@/moduleApi/ProjectApi";

export default {
  components: {
    ElementUiMoney,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      tableData: [],
      MethodService,
      showRevenueByDay: false,
      currentCompany: MethodService.getCompanyInfo(),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      tableRules: MethodService.copyObject(BusinessModel.tableRules),
      tableRuleRevenuByDays: MethodService.copyObject(BusinessModel.tableRuleRevenuByDays),
      dataForm: MethodService.copyObject(BusinessModel.dataForm),
      beforeRowClickIndex: undefined,
      beforeRowClickData: undefined,
      beforeRowClickDataClone: undefined,
      beforeRowRevenueClickIndex: undefined,
      beforeRowRevenueClickData: undefined,
      beforeRowRevenueClickDataClone: undefined,
      listTypeRevenue: [
        {
          value: 'NEW',
          label: 'Doanh thu mới',
        },
        {
          value: 'MAIN_TAIN',
          label: 'Doanh thu duy trì',
        },
      ],
      employeeIdRowClicked: undefined,
      listEmployeeOfDepartment: [],
      listDepartments: [],
      listProjects: [],
      listEnabledDepartments: [],
      listDepartmentHasUsed: [],
      listEmployees: [],
      promiseGetRevenueByDay: [],
      dataRevenueByDay: [],
      currentRevenueBayDayId: undefined,
      inputMoneyValidate: true,
      inputRevenueByDayMoneyValidate: true,
      loadingButtonCreate: false,
      loadingButtonUpdate: false,
      loadingButtonCreateRevenueByDay: false,
      loadingButtonUpdateRevenueByDay: false,
    }
  },
  methods: {
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (MethodService.checkHaveFeature('FT2003')) {
        return
      } else {
        return 'cell-class-name-custom'
      }
    },
    async initData() {
      Promise.all([
        DepartmentApi.list({
          filters: 'disabled!=true',
          fields: 'id,name',
          limit: 1000,
        })
      ]).then((res) => {
        console.log('res', res)
        this.listDepartments = res[0].result
        this.listEnabledDepartments = [...res[0].result]
        this.getBusinessPlan()
        this.getProjectList()
      })
    },
    async getListDepartmentHasUsed(arrIds) {
      const listDepartmentHasUsed = await DepartmentApi.list({
        filters: `id:in:${arrIds.join(',')}`,
        fields: 'id,name',
        limit: 1000,
      })
      this.listDepartmentHasUsed = listDepartmentHasUsed.result
    },
    async getBusinessPlan() {
      this.listEmployeeOfDepartment = []
      try {
        const resLimit1Api = await BusinessPlanApi.list({
          filters: this.tableRules.filters,
          fields: 'id',
          limit: 1,
        })
        const resApi = await BusinessPlanApi.getListBussinessPlanDetail({
          limit: this.tableRules.limit,
          skip: this.tableRules.offset,
        });
        this.$router
        .replace({
          name: "Admin-Business-list",
          query: {
            limit: this.tableRules.limit,
            page: this.tableRules.page,
            filters: this.tableRules.filters
          }
        })
        .catch(err => {});
        this.tableData = MethodService.copyObject(resApi.result)
        await this.getListDepartmentHasUsed(MethodService.findListItemDifferent(resApi.result, 'department_id'))
        this.tableRules.total = resLimit1Api.meta.total
        this.tableRules.page = this.tableRules.offset / this.tableRules.limit + 1;
        let arrEmployeeIds = []
        arrEmployeeIds = MethodService.findListItemDifferent(this.tableData, 'employee_id')
        if (MethodService.checkHaveFeature('FT2002')) {
          this.tableData.unshift({
            project_id: undefined,
            department_id: undefined,
            employee_id: undefined,
            expected_revenue: undefined,
            deadline: undefined,
            is_new: true,
            note: undefined,
            show_input: true,
          })
        }
        if (arrEmployeeIds.length == 0) {
          this.listEmployees = []
          return
        }
        this.getEmployee(arrEmployeeIds)
      } catch (error) {
        this.tableData = []
      }
    },
    async getProjectList() {
     const res = await ProjectApi.list(
     {
        filters: "company_id=" + this.currentCompany.id,
        limit: 9999999,
        fields: "id,name",
      });
      if(res.result){
        this.listProjects = res.result;
      }
    },
    getTotalRevuene() {
      Promise.all(this.promiseGetRevenueByDay).then((res) => {
        res.forEach((item, index) => {
          let total = 12315789
          item.result.forEach(item => {
            total += parseInt(item.revenue)
          })
          this.tableData[index + 1].revenue_by_day = total
        })
      })
    },
    async getEmployee(arrIds) {
      if (arrIds.length == 0) this.listEmployees = []
      const resApi = await EmployeeApi.list({
        filters: `id:in:${arrIds.join(',')}`,
        fields: 'id,administrative_info',
        limit: arrIds.length,
      })
      this.listEmployees = resApi.result
    },
    getNameEmployee(id) {
      const employee = this.listEmployees.find((item) => item.id == id)
      if (employee) return employee.administrative_info.name.full_name
      return ''
    },
    getNameDepartment(id) {
      const department = this.listDepartmentHasUsed.find((item) => item.id == id)
      if (department) return department.name
      return ''
    },
    getNameProject(id) {
      const project = this.listProjects.find((item) => item.id == id)
      if (project) return project.name
      return ''
    },
    checkHaveDepartment(departmentId) {
      let haveDepartment = this.listDepartments.find(e => e.id === departmentId)
      if (haveDepartment) return
      this.listDepartments.push(this.listDepartmentHasUsed.find(e => e.id === departmentId))
    },
    checkHaveEmployee(employeeId) {
      let haveEmployee = this.listEmployeeOfDepartment.find(e => e.id === employeeId)
      if (haveEmployee) return
      let employee = this.listEmployees.find(e => e.id === employeeId)
      this.listEmployeeOfDepartment.push({
        id: employee.id,
        name: employee.administrative_info.name.full_name
      })
    },
    handleEdit(row, index) {
      if (!MethodService.checkHaveFeature('FT2003')) return
      this.listDepartments = [...this.listEnabledDepartments]
      this.checkHaveDepartment(row.department_id)
      this.employeeIdRowClicked = row.employee_id
      if (this.beforeRowClickIndex != undefined) {
        this.tableData[this.beforeRowClickIndex] = this.beforeRowClickDataClone
        this.tableData[this.beforeRowClickIndex].show_input = false
      }
      if (MethodService.checkHaveFeature('FT2002')) {
        this.tableData[0] = {
          project_id: undefined,
          note: undefined,
          department_id: undefined,
          employee_id: undefined,
          expected_revenue: undefined,
          deadline: undefined,
          is_new: true,
          show_input: false,
        }
      }
      this.beforeRowClickData = Object.assign({...MethodService.copyObject(row)})
      this.beforeRowClickDataClone = Object.assign({...MethodService.copyObject(this.beforeRowClickData)})
      this.beforeRowClickIndex = index
      this.beforeRowClickData.show_input = true
      this.tableData = this.tableData.filter((item) => item.id != row.id)
      this.handleSelectDepartment(row.department_id, index, 'show')
      setTimeout(() => {
        this.tableData.splice(index, 0, this.beforeRowClickData)
      }, 50);
    },
    handleEditTable(row, index) {
      this.dataRevenueByDay[0].show_input = false
      this.dataRevenueByDay[0].revenue = undefined
      this.dataRevenueByDay[0].revenue_date = undefined
      this.dataRevenueByDay[0].type = undefined

      if (this.beforeRowRevenueClickIndex) {
        let dataBefore = MethodService.copyObject(this.beforeRowRevenueClickData)
        let dataBeforeRowClickIndex = MethodService.copyObject(this.beforeRowRevenueClickIndex)
        this.dataRevenueByDay[this.beforeRowRevenueClickIndex].show_input = false
        this.dataRevenueByDay = this.dataRevenueByDay.filter((item) => item.id != dataBefore.id)
        dataBefore.show_input = false
        setTimeout(() => {
          this.dataRevenueByDay.splice(dataBeforeRowClickIndex, 0, dataBefore)
        }, 10)
      }
      this.beforeRowRevenueClickData = Object.assign({...MethodService.copyObject(row)})
      this.beforeRowRevenueClickDataClone = Object.assign({...MethodService.copyObject(this.beforeRowRevenueClickData)})
      this.beforeRowRevenueClickIndex = index
      this.beforeRowRevenueClickData.show_input = true
      this.dataRevenueByDay = this.dataRevenueByDay.filter((item) => item.id != row.id)
      setTimeout(() => {
        this.dataRevenueByDay.splice(index, 0, this.beforeRowRevenueClickData)
      }, 10);
    },
    handleSelectDepartment(id, index, type) {
      if (type != 'show') this.tableData[index].employee_id = undefined
      Promise.all([
        EmployeeApi.GetListEmployeeByDepartment({
          department_id: id
        })
      ]).then((res) => {
        this.listEmployeeOfDepartment = res[0].result.employees
        if (!this.employeeIdRowClicked) return
        this.checkHaveEmployee(this.employeeIdRowClicked)
      })
    },
    forceUpdateUI() {
      this.$forceUpdate()
    },
    //Submit
    async addNewPlan(row) {
      this.$root.$emit('bv::hide::popover')
      try {
        this.loadingButtonCreate = true
        let data = {
          employee_id: row.employee_id,
          expected_revenue: row.expected_revenue,
          deadline: row.deadline,
          department_id: row.department_id,
          note: row.note,
          project_id: row.project_id,
          month: new Date(row.deadline).getMonth() + 1,
          year: new Date(row.deadline).getFullYear(),
        }
        await BusinessPlanApi.create(data)
        toastr.success('Thêm mới kế hoạch thành công')
        setTimeout(() => {
          this.getBusinessPlan()
        }, 800)
        this.loadingButtonCreate = false
      } catch (error) {
        console.log('error', error)
        toastr.error('Thêm mới kế hoạch thất bại')
        this.loadingButtonCreate = false
      }
    },
    async updatePlan(index, row, type) {
      this.$root.$emit('bv::hide::popover')
      if (type == 'cancel') {
        this.listEmployeeOfDepartment = []
        this.tableData = this.tableData.filter((item) => item.id != row.id)
        this.beforeRowClickDataClone.show_input = false
        this.listDepartments = [...this.listEnabledDepartments]
        this.employeeIdRowClicked = undefined
        setTimeout(() => {
          this.tableData.splice(index, 0, this.beforeRowClickDataClone)
          this.clearDataRowPlanClick()
        }, 50)
        this.tableData[0].show_input = true
        return
      }
      try {
        this.loadingButtonUpdate = true
        let data = {
          id: row.id,
          employee_id: row.employee_id,
          expected_revenue: row.expected_revenue,
          deadline: row.deadline,
          project_id: row.project_id,
          note: row.note,
          department_id: row.department_id,
          month: new Date(row.deadline).getMonth() + 1,
          year: new Date(row.deadline).getFullYear(),
        }
        await BusinessPlanApi.update(data)
        toastr.success('Cập nhật kế hoạch doanh thu thành công')
        this.listDepartments = [...this.listEnabledDepartments]
        this.employeeIdRowClicked = undefined
        this.getBusinessPlan()
        this.clearDataRowPlanClick()
        this.loadingButtonUpdate = false
      } catch (error) {
        toastr.error('Cập nhật kế hoạch doanh thu thất bại')
        this.loadingButtonUpdate = false
      }
    },
    async deletePlan(row) {
      this.$root.$emit('bv::hide::popover')
      this.$confirm('Bạn có chắc chắn muốn xóa kế hoạch này không?', 'Xác nhận', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(async () => {
        try {
          await BusinessPlanApi.delete(row.id)
          toastr.success('Xóa kế hoạch doanh thu thành công')
          this.getBusinessPlan()
        } catch (error) {
          if (error.detail) {
            toastr.error(error.detail)
          } else {
            toastr.error('Xóa kế hoạch doanh thu thất bại')
          }
        }
      }).catch((erroe) => {
        console.log(erroe)
      })
    },
    getDataRevenueByDay(id) {
      Promise.all([
        RevenueByDayApi.list({
          filters: `business_plan_id=${id}`,
          sort: this.tableRuleRevenuByDays.sort,
          limit: this.tableRuleRevenuByDays.limit,
          offset: this.tableRuleRevenuByDays.offset,
        })
      ]).then((res) => {
        this.dataRevenueByDay = res[0].result
        this.tableRuleRevenuByDays.total = res[0].meta.total
        this.dataRevenueByDay.unshift({
          business_plan_id: id,
          revenue: undefined,
          revenue_date: undefined,
          type: undefined,
          is_new: true,
          show_input: true,
        })
      })
    },
    async handleShowRevenueByDay(row) {
      this.getDataRevenueByDay(row.id)
      this.currentRevenueBayDayId = row.id
      this.showRevenueByDay = true
    },
    revenueByDayClose(done) {
      this.currentRevenueBayDayId = undefined
      this.showRevenueByDay = false
      this.beforeRowRevenueClickData = []
      this.beforeRowRevenueClickIndex = undefined
      this.tableRuleRevenuByDays = MethodService.copyObject(BusinessModel.tableRuleRevenuByDays)
      done()
    },
    //Submit dialog
    async addNewRevenueByDay(row) {
      try {
        this.$root.$emit('bv::hide::popover')
        this.loadingButtonCreateRevenueByDay = true
        let data = {
          business_plan_id: row.business_plan_id,
          revenue: row.revenue,
          revenue_date: row.revenue_date,
          rating: row.rating,
          note: row.note,
          type: row.type,
        }
        await RevenueByDayApi.create(data)
        toastr.success('Thêm mới doanh thu thành công')
        setTimeout(() => {
          this.getDataRevenueByDay(data.business_plan_id)
          this.getBusinessPlan()
        }, 800)
        this.loadingButtonCreateRevenueByDay = false
      } catch (error) {
        toastr.error('Thêm mới doanh thu thất bại')
        this.loadingButtonCreateRevenueByDay = false
      }
    },
    //Doanh thu theo ngày
    async updateRevenueByDay(index, row, type) {
        this.$root.$emit('bv::hide::popover')
      if (type == 'cancel') {
        this.listEmployeeOfDepartment = []
        this.dataRevenueByDay = this.dataRevenueByDay.filter((item) => item.id != row.id)
        this.beforeRowRevenueClickDataClone.show_input = false
        setTimeout(() => {
          this.dataRevenueByDay.splice(index, 0, this.beforeRowRevenueClickDataClone)
          this.clearDataRowRevenuaClick()
        }, 10);
        this.dataRevenueByDay[0].show_input = true
        return
      }
      try {
        this.loadingButtonUpdateRevenueByDay = true
        let data = {
          id: row.id,
          business_plan_id: row.business_plan_id,
          revenue: row.revenue,
          revenue_date: row.revenue_date,
          rating: row.rating,
          note: row.note,
          type: row.type,
        }
        await RevenueByDayApi.update(data)
        toastr.success('Cập nhật doanh thu theo ngày thành công')
        this.getDataRevenueByDay(data.business_plan_id)
        this.getBusinessPlan()
        this.clearDataRowRevenuaClick()
        this.loadingButtonUpdateRevenueByDay = false
      } catch (error) {
        console.log('error', error)
        toastr.error('Cập nhật kế hoạch doanh thu theo ngày thất bại')
        this.loadingButtonUpdateRevenueByDay = false
      }
    },
    clearDataRowRevenuaClick() {
      this.beforeRowRevenueClickIndex = undefined
      this.beforeRowRevenueClickData = undefined
      this.beforeRowRevenueClickDataClone = undefined
    },
    clearDataRowPlanClick() {
      this.beforeRowClickIndex = undefined
      this.beforeRowClickData = undefined
      this.beforeRowClickDataClone = undefined
    },
    async createRevenueByDay(row) {},
    async deleteRevenueByDay(row) {
      this.$root.$emit('bv::hide::popover')
      this.$confirm(`Bạn có chắc chắn muốn xóa doanh thu ngày ${MethodService.formatDate(row.revenue_date, 'date')} không?`, 'Xác nhận', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(async () => {
        try {
          await RevenueByDayApi.delete(row.id)
          toastr.success('Xóa doanh thu thành công')
          this.getDataRevenueByDay(row.business_plan_id)
          this.getBusinessPlan()
        } catch (error) {
          console.log('error', error)
          toastr.error('Xóa doanh thu thất bại')
        }
      }).catch((erroe) => {
        console.log(erroe)
      })
    },
    //event table
    fn_tableSizeChange(limit) {
      this.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.tableRules.page = page;
      this.tableRules.offset =
        (this.tableRules.page - 1) * this.tableRules.limit;
      this.initData()
    },
    //event table RevenuByDay
    fn_tableRevenuByDaySizeChange(limit) {
      this.tableRuleRevenuByDays.limit = limit;
      this.fn_tableRevenuByDayChangeOffset(this.tableRuleRevenuByDays.page);
    },
    fn_tableRevenuByDayCurentChange(page) {
      this.fn_tableRevenuByDayChangeOffset(page);
    },
    fn_tableRevenuByDayPrevClick(page) {
      this.fn_tableRevenuByDayChangeOffset(page);
    },
    fn_tableRevenuByDayNextClick(page) {
      this.fn_tableRevenuByDayChangeOffset(page);
    },
    fn_tableRevenuByDayChangeOffset(page) {
      this.tableRuleRevenuByDays.page = page;
      this.tableRuleRevenuByDays.offset =
        (this.tableRuleRevenuByDays.page - 1) * this.tableRuleRevenuByDays.limit;
      this.getDataRevenueByDay(this.currentRevenueBayDayId)
    },
    checkInputMoney(value) {
      if (!value) return
      if (value.length > 15) {
        toastr.warning('Số tiền không được quá 15 ký tự')
        this.inputMoneyValidate = false
        EventBus.$emit('focusInput')
      } else {
        this.inputMoneyValidate = true
      }
    },
    checkRevenueByDayInputMoney(value) {
      if (!value) return
      if (value.length > 15) {
        toastr.warning('Số tiền không được quá 15 ký tự')
        this.inputRevenueByDayMoneyValidate = false
        EventBus.$emit('focusInput')
      } else {
        this.inputRevenueByDayMoneyValidate = true
      }
    },
  },
  created() {
    MethodService.checkHavePermission('FT2001')
    this.initData()
  },
}
</script>

<style lang="scss" scoped>
.note {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
::v-deep .cell-class-name-custom {
  height: 50px;
}
:deep(.input-money) {
  .el-input__inner {
    text-align: center;
  }
}
:deep(.el-date-editor) {
  .el-input__inner {
    text-align: center;
  }
}
:deep(.total-revenue) {
  display: flex;
  align-items: center;  
  justify-content: center;
  p {
    &:first-child {
      margin-right: 15px;
      font-weight: 600;
      font-size: 14.5px;
    }
  }
}
:deep(.dialog-revenue-by-day) {
  .el-dialog {
    width: 65%;
    margin-top: 3% !important;
    .el-dialog__body {
      max-height: calc(100vh - 140px);
    }
  }
}
@media (max-width: 1370px) {
  :deep(.dialog-revenue-by-day) {
    .el-dialog {
      width: 80%;
    }
  }
}
</style>
